
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M13.453 3h-10.906a1.547 1.547 0 0 0-1.547 1.547v6.906a1.547 1.547 0 0 0 1.547 1.547h10.906a1.547 1.547 0 0 0 1.547-1.547v-6.906a1.547 1.547 0 0 0-1.547-1.547Zm.172 2.781-5 4a1 1 0 0 1-1.25 0l-5-4a1.00029296 1.00029296 0 0 1 1.25-1.562L8 7.72l4.375-3.5a1.00029296 1.00029296 0 1 1 1.25 1.562Z"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  